import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { InfoOutlined as InfoIcon } from "@mui/icons-material";

const useStyles = makeStyles(() => ({
    permissionsIcon: {
        position: "relative",
        top: "3.5px",
        marginLeft: "1px",
        fontSize: 20,
    },
}));

export const ContractProductDetail = ({ productDetails }) => {
    const classes = useStyles();

    if (!productDetails) return null;

    return (
        <Tooltip
            className={classes.permissionsIcon}
            title={
                <Box display="flex" flexDirection="column" p={2}>
                    <Typography variant="subtitle1">Product Details</Typography>
                    <Typography>{productDetails}</Typography>
                </Box>
            }
            arrow
            placement="right-start"
        >
            <InfoIcon
                
            />
        </Tooltip>
    );
};

export default ContractProductDetail;
